module.exports = __webpack_public_path__ + "img/size5.9b068024.png";